import {ref} from 'vue';
import {acceptHMRUpdate, defineStore} from 'pinia';
import useApi from '~/composables/useApi';
import type {ProblemDetail} from '~/lib/types/fetchErrors';

export const useCatalogVersionStore = defineStore('catalogVersion', () => {
	const {GET, POST} = useApi();

	const loading = ref(false);
	const problemDetail = ref<ProblemDetail>();

	const catalogVersion = ref<string | null>(null);

	type ActivateCatalogCommand = { filename: string };
	const availableCatalogs = ref<string[]>();

	const activateNewCatalog = async (activateCatalogCommand: ActivateCatalogCommand) => {
		loading.value = true;
		problemDetail.value = undefined;

		const {error} = await POST(
			`/catalog`,
			{
				body: activateCatalogCommand
			}
		);

		if (error) {
			problemDetail.value = error;
			loading.value = false;
			return false;
		}

		loading.value = false;
		return true;

	};

	const fetchAvailableCatalogs = async () => {
		loading.value = true;
		problemDetail.value = undefined;

		const {data, error} = await GET(`/catalog`);

		if (error || !data) {
			loading.value = false;
			problemDetail.value = error;
			return false;
		}

		availableCatalogs.value = data;

		loading.value = false;
		return true;
	};

	return {
		loading,
		problemDetail,
		catalogVersion,
		availableCatalogs,
		activateNewCatalog,
		fetchAvailableCatalogs
	};
});

if (import.meta.hot) {
	import.meta.hot.accept(acceptHMRUpdate(useCatalogVersionStore, import.meta.hot));
}
